<div class="select">
  @if (labelText) {
    <label class="select__label">{{ labelText }}</label>
  }
  <select
    name="name"
    class="select__select-input"
    (change)="listenForChange($event)"
    [disabled]="disabled"
    [ngClass]="{ 'placeholder-active': selectedOption === '' }"
    >
    @if (placeholderText) {
      <option value="" [selected]="selectedOption === ''">
        {{ placeholderText }}
      </option>
    }
    @for (option of options; track option) {
      <option
        value="{{ option.value || option }}"
      [selected]="
        option.value
          ? option.value === selectedOption
          : option === selectedOption
      "
        >
        {{ option.label || option | titleText }}
      </option>
    }
  </select>
  <i class="fa fa-caret-down select__icon"></i>
</div>
